import getInstanceAxios from "../requestLuague"
function instanceAxios(token) {
  return getInstanceAxios(token)
}

export default instanceAxios
